import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import { Table } from 'reactstrap'
import './list-pendencies.css'



class ListPendencies extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            groupFailure: [],
            table: {},
            alert: { msg: '', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                groupFailure: [],
                idDrivers: [],
                idVehicles: [],
                licenseNumbers: []
            }

        }
    }




    componentDidMount() {
        this.getPendencies()
        this.getFailures();
    }

    getFailures = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/checklist/groupFailures/${this.props.token}`)
            .then(d => {
                this.setState({ groupFailure: d.data });
            })
            .catch(e => console.log(e.response));
    };

    getPendencies = data => {
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/checklist/issues/${this.props.token}`,
            data
        }).then(d => {
            if (d.data.listChecklistIssue.length) {
                this.setState({ loading: false, table: d.data.listChecklistIssue, filter: d.data.reportFilter, totalClosedIssue: d.data.totalClosedIssue })
            } else {
                this.setState({
                    loading: false,
                    alert: {
                        type: "",
                        msg:
                            "Não foi possivel localizar resultados para o período selecionado."
                    }
                });
            }
            console.log(d.data)
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({loading: false})
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };

    changeInput = (val, i) => {
        var table = this.state.table;
        table[i].resolutionDate = val
        this.setState({ table })
    }

    save = i => {
        var table = this.state.table
        table[i].loading = true
        this.setState({ table, toast: [] })
        if (table[i].resolutionDate) {
            axios.post(`${url}/v1/telemetria/checklist/issues/update/${this.props.token}`, { ...table[i] })
                .then(d => {
                    console.log(d)
                    table.splice(i, 1)
                    this.setState({
                        table,
                        totalClosedIssue: this.state.totalClosedIssue + 1
                    })
                    store.addNotification({ ...this.props.bodyNotify, title: 'Pendência Resolvida', type: 'success' });
                })
                .catch(e => {
                    // this.props.validateToken(this.props.token)
                    console.log(e.response);
                    table[i].loading = false
                    var errorMsg = e.response.data.errorMessage
                    errorMsg.forEach(d => {
                        if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                        else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                    })
                    this.setState({ table })

                })
        } else {
            setTimeout(() => {
                table[i].loading = false
                // table.splice(i, 1)
                this.setState({ table })
                store.addNotification({ ...this.props.bodyNotify, title: 'Data de resolução não foi preenchida.', type: 'danger' });
            }, 300);
        }
    }


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()} 
                        value={this.state.filter.startPeriod}/>
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, licenseNumbers: [] } })
                            }
                            else {
                                let licenseNumbers = []
                                i.forEach(d => licenseNumbers.push(d.label))
                                this.setState({ filter: { ...this.state.filter, licenseNumbers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Falhas</label>

                    {/* Select Falhas */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Falhas"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.groupFailure}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, groupFailure: [] } })
                            }
                            else {
                                let groupFailure = []
                                i.forEach(d => groupFailure.push(d.value))
                                this.setState({ filter: { ...this.state.filter, groupFailure } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />

                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getPendencies(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div>
                        <div className='legend-pendencie'>
                            <span className='text-color'>Pendências resolvidas: <b>{this.state.totalClosedIssue}</b></span>
                        </div>
                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '200px'}}># Número</th>
                                    <th style={{ minWidth: '200px'}}>Data Criação</th>
                                    <th style={{ minWidth: '200px'}}>Nome</th>
                                    <th style={{ minWidth: '200px'}}>Frota</th>
                                    <th style={{ minWidth: '200px'}}>Titulo</th>
                                    <th style={{ minWidth: '450px'}}>Descrição</th>
                                    <th style={{ minWidth: '198px'}}>Observações</th>
                                    <th style={{ minWidth: '198px'}}>Resolver Pendência</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.table.map((d, i) => {
                                    const styleLine = { color: d.emergency ? 'red' : null, minWidth: '198px' }
                                    const value = d.resolutionDate || 'yyyy-mm-dd'

                                    return (
                                        <tr key={i} className="tr-table-change-color">

                                            <td style={styleLine}><strong>{d.number}</strong></td>
                                            <td style={{...styleLine}}>{d.createDate}</td>
                                            <td style={styleLine}>{d.driverName}</td>
                                            <td style={styleLine}>{d.licenseNumber}</td>
                                            <td style={styleLine}>{d.title}</td>
                                            <td style={{...styleLine, minWidth: '450px'}}>{d.description}</td>
                                            <td style={styleLine}>{d.obs}</td>
                                            <td style={{ minWidth: '198px'}}>
                                                <div className="input-case">
                                                    <input
                                                        type="date"
                                                        className="form-control 
                                                        input-change-color input-pendencie"
                                                        placeholder='Data Resolução'
                                                        disabled={d.loading}
                                                        value={value}
                                                        onChange={(e) => { this.changeInput(e.target.value, i) }} />
                                                    {d.loading ?
                                                        <div style={{ margin: '10px 0 0 25px' }}>
                                                            <Loading size='small' />
                                                        </div> :
                                                        <i className="fa fa-check-circle btn-table-icon" onClick={() => this.save(i)}></i>}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default ListPendencies